import { Boxes, AlertOctagon, Clock, ShieldCheck } from 'lucide-react';
import Panel from '@/components/Panel';


/** The shared frame for the sign-in screen. */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen flex-col bg-[var(--app-bg)] pt-safe pb-safe lg:flex-row">
      {/* Brand panel — desktop only, keeps the mobile view focused on the form.
          The three swatches are the app's actual expiry ramp, so the colour
          language is learned before the first product row is ever seen. */}
      <div className="hidden bg-primary-700 p-10 text-white lg:flex lg:w-2/5 lg:flex-col lg:justify-between">
        <div className="flex items-center gap-2">
          <Boxes className="h-7 w-7 text-accent-400" />
          <span className="text-xl font-extrabold tracking-tight">Zorzo</span>
        </div>
        <div className="space-y-6">
          <h2 className="text-3xl font-bold leading-tight">
            Know what expires next — before your customers do.
          </h2>
          <p className="max-w-md text-primary-100">
            Every batch in the warehouse, sorted by how little time it has left.
          </p>
          <div className="space-y-2.5">
            {[
              [AlertOctagon, '#fda4af', 'Expired — pull it off the shelf'],
              [Clock, '#fcd34d', 'Expiring soon — move it this week'],
              [ShieldCheck, '#6ee7b7', 'Fresh — nothing to do'],
            ].map(([LineIcon, color, text]) => (
              <div key={text} className="flex items-center gap-2.5 text-sm text-primary-100">
                <LineIcon size={16} style={{ color }} strokeWidth={2.5} />
                {text}
              </div>
            ))}
          </div>
        </div>
        <p className="text-xs text-primary-200">Warehouse Product Expiry Tracker</p>
      </div>

      {/* Form panel */}
      <div className="flex flex-1 items-center justify-center p-4 sm:p-8">
        <div className="w-full max-w-md">
          <div className="mb-6 flex items-center justify-center gap-2 lg:hidden">
            <Boxes className="h-6 w-6 text-primary-600" />
            <span className="text-lg font-extrabold text-primary-700">Zorzo</span>
          </div>
          <Panel className="p-6 sm:p-8">
            <div className="mb-6">
              <h1 className="text-xl font-bold text-[var(--app-text)]">{title}</h1>
              {subtitle ? <p className="mt-1 text-sm text-[var(--app-muted)]">{subtitle}</p> : null}
            </div>
            {children}
          </Panel>
          {footer ? <div className="mt-4 text-center text-sm text-[var(--app-muted)]">{footer}</div> : null}
        </div>
      </div>
    </div>
  );
}
